import searchHelper from '../search/searchHelper'

export default (data) => ({
    ...searchHelper,
    // for category page , list of category options can be passed from the page itself
    categoryOptions: 'categories' in data && data.categories.length > 0 ? data.categories : [],
    // lock category options
    categoryOptionsLocked: 'categoriesLocked' in data ? data.categoriesLocked : false,
    // predefine selections for immediate search
    displayMobileFilters: false,
    displayAdvancedFilters: false,
    productQueryId: null,
    init() {
        // add filter for category page
        this.filteredCategory.push(this.categoryOptions[0].id_category)

        this.extractPotentialFiltersFromQuery()

        if (Object.keys(this.categoryFiltersSelections).length === 0) {
            this.applyAllFiltersFromStorage()
        } else {
            const categoryDataIndex = this.getPersistedIndex()
            if (categoryDataIndex === -1) {
                if (this.storedCategoryFilters.active_filters.length >= process.env.MIX_NUMBER_PERSIST_CATEGORY_FILLTERS) {
                    this.storedCategoryFilters.active_filters.shift()
                }

                this.storedCategoryFilters.active_filters.push({
                    category: this.filteredCategory[0],
                    filters: this.categoryFiltersSelections,
                    page: 1,
                })
            }
        }

        // figure out page to go for and load products
        const categoryDataIndex = this.getPersistedIndex()
        if (categoryDataIndex !== -1 && this.storedCategoryFilters.active_filters[categoryDataIndex].page && this.storedCategoryFilters.active_filters[categoryDataIndex].page !== 1) {
            this.loadProducts(parseInt(this.storedCategoryFilters.active_filters[categoryDataIndex].page, 10))
        } else {
            this.loadProducts(1)
        }

        this.pageUsedOn = 'Category Page'
        this.pageUsedOnId = `category_page_${this.categoryOptions[0].id_category}`
    },
    updateUrl() {
        const suffixStartPosition = `${this.currentIso}.features.`.length
        const filters = Object.keys(this.categoryFiltersSelections)
            .filter((key) => this.categoryFiltersSelections[key].length)
            .reduce((a, v) => ({
                ...a,
                [v.substring(suffixStartPosition)]: this.categoryFiltersSelections[v].join(','),
            }), {})

        if (this.expressStockOnly) {
            filters.express = '1'
        }

        if (this.getCurrentPage() > 1) {
            filters.page = this.getCurrentPage()
        }

        this.trackingQueryParametersData.forEach(({ key, value }) => {
            filters[key] = value
        })

        const query = window.helpers.buildQueryString(filters)
        const nextURL = `${window.location.pathname}?${query}`.replace(/\?$/, '')
        window.history.pushState(null, document.title, nextURL)
    },
    applyAllFiltersFromQuery() {
        this.categoryFilters.filter((f) => window.helpers.getQueryVar(f.name))
            .forEach((f) => this.applyFilterFromQuery(
                f.name,
                window.helpers.getQueryVar(f.name).split(','),
            ))
    },
    buildQueries(currentPage) {
        const productCategoryFacets = []
        if (this.filteredCategory.length > 0) {
            this.filteredCategory.forEach((filterId) => {
                productCategoryFacets.push(`category_id:${filterId}`)
            })
        }

        const productFacetFilters = [productCategoryFacets]

        if (Object.keys(this.categoryFiltersSelections).length > 0) {
            Object.keys(this.categoryFiltersSelections).forEach((key) => {
                const entries = []
                this.categoryFiltersSelections[key].forEach((item) => {
                    entries.push(`${key}: ${item}`)
                })
                productFacetFilters.push(entries)
            })
        }

        if (this.expressStockOnly) {
            productFacetFilters.push(['in_stock:3'])
        }

        if (this.brand != null) {
            productFacetFilters.push([`manufacturer_name:${this.brand}`])
        }

        const facets = [`${this.currentIso}.category_data`]
        this.categoryFilters.forEach((filter) => {
            facets.push(`${this.currentIso}.features.${filter.name}`)
        })

        // 0st , gets main filters for positionings
        // 1nd , gets advanced filters and facet options
        // 2rd , get products
        // 3th and onwards FILTERS
        const queries = [
            {
                indexName: 'new_product_categories',
                query: this.query,
                params: {
                    hitsPerPage: 1,
                    page: 0,
                    facetFilters: `objectID:${this.filteredCategory[0]}`,
                },
                clickAnalytics: true,
            },
            {
                indexName: 'new_products',
                query: this.query,
                params: {
                    hitsPerPage: 1,
                    page: 0,
                    facetFilters: productFacetFilters,
                    facets: ['*'],
                },
            },
            {
                indexName: 'new_products',
                query: this.query,
                restrictSearchableAttributes: [
                    'manufacturer_name',
                    'reference',
                    `${this.currentIso}.title`,
                    `${this.currentIso}.meta_keywords`,
                    `${this.currentIso}.meta_description`,
                    `${this.currentIso}.category_name`,
                    `${this.currentIso}.attributes`,
                ],
                params: {
                    hitsPerPage: this.pagination.step,
                    page: currentPage - 1,
                    facetFilters: productFacetFilters,
                    facets: ['*'],
                },
            },
        ]

        // now lets loop over filters to get appropriate facets if any selection or express is set
        // if no selection is set , then we should have correct filters from 2nd query
        if (Object.keys(this.categoryFiltersSelections).length !== 0 || this.expressStockOnly) {
            this.categoryFilters.forEach((filter) => {
                queries.push(this.createFilterQueriesFromKey(`${this.currentIso}.features.${filter.name}`))
            })
        }

        const selectionFillQueries = []
        if (Object.keys(this.categoryFiltersSelections).length > 0 && this.categoryFilters.length === 0) {
            Object.keys(this.categoryFiltersSelections).forEach((key) => {
                selectionFillQueries.push(this.createFilterQueriesFromKey(key))
            })
        }

        return [queries, selectionFillQueries]
    },

    loadProducts(page) {
        const expressInUrl = window.helpers.getQueryVar('express') === '1'
        if (expressInUrl === '1') {
            this.expressStockOnly = true
        }

        this.loadingProducts = true
        let currentPage = page

        if (this.pagination.page !== this.getCurrentPage()) {
            currentPage = this.getCurrentPage()
        }

        if (page === null) {
            currentPage = this.pagination.page
        }

        this.setCurrentPage(currentPage)
        const queries = this.buildQueries(currentPage)

        const originalQueryCount = queries[0].length

        queries[0] = queries[0].concat(queries[1])

        window.api.search(queries[0]).then((searchResults) => {
            for (let index = 0; index < searchResults.length; index += 1) {
                // 0 - main filters
                // 1 - advanced filters and facet options
                // 2 - products
                // 3 and onwards - individual filter queries if any selection or express is set
                if (index === 0) {
                    this.productQueryId = searchResults[index].queryID
                    this.processMainCategoryFilters(searchResults[index])
                }

                if (index === 1) {
                    this.processFacetOptions(searchResults[index])
                }

                if (index === 2) {
                    this.processProducts(searchResults[index], this.getCurrentPage())
                }

                if (index >= 3 && index < originalQueryCount) {
                    const filterIndex = index - 3
                    this.processIndividualFacetOptions(searchResults[index], filterIndex)
                }

                if (index >= originalQueryCount) {
                    // processing backfill filters
                    this.backFillFacetOptions(searchResults[index])
                }
            }
        })

        window.dispatchEvent(new CustomEvent('product-search-updated'))
        this.filtersChanged = false
    },
})
